export default "__VITE_ASSET__CaaGnnSo__"